import * as React from 'react';

export enum CognitoException {
    NotAuthorizedException = 'NotAuthorizedException',
    LimitExceededException = 'LimitExceededException',
    UserNotFoundException = 'UserNotFoundException',
    InvalidParameterException = 'InvalidParameterException',
    UserNotConfirmedException = 'UserNotConfirmedException',
    CodeMismatchException = 'CodeMismatchException',
    ExpiredCodeException = 'ExpiredCodeException'
}

export enum CognitoResetPasswordExceptionMessage {
    IncorrectPassword = 'Your current password is incorrect.',
    LimitExceeded = 'You have attempted to reset your password too many times. Please try again later.',
}

export const ResendVerificationCodeComponent = (props: {resendCode: () => Promise<void>}): JSX.Element => {
    return (
        <React.Fragment>
            Please check your email for instructions or <a href="javascript:void(0)" style={{ color: '#5e91cc' }} onClick={props.resendCode}>send a new verification code</a>.
        </React.Fragment>
    );
};

export enum CognitoGenericExceptionMessage {
    AccountInvalid = 'Wrong e-mail address or password.',
    InvalidParameter = 'Please enter your email address and try again.',
}


// WEBPACK FOOTER //
// ./src/webportal/components/authentication/errors/CognitoErrors.tsx